(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gcww-vote"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(event) {
	const form = document.getElementById('gcww-vote-form');
	const shadowWrapper = document.querySelector('div[data-forms-id="forms-root-867145"]')

	const observer = new MutationObserver((mutationList) => {
		for (const mutation of mutationList) {
			if(mutation.type === 'childList' || mutation.type === 'subtree') {
				const shadowWrapperL = document.querySelector('div[data-forms-id="forms-root-867145"]')
				const formEmbed = shadowWrapperL.querySelector(['shopify-forms-embed']);

				if(formEmbed) {
					const shadow = formEmbed.shadowRoot;
					const style = document.createElement('style');

					const stylesForForm = `
					#app-embed::after,#app-embed::before{background-size:cover;pointer-events:none}section[data-sizing=form-wrapper] button,section[data-sizing=form-wrapper] input[type=text]{font-family:Agipo Mono,sans-serif!important;font-size:2rem!important;font-style:normal!important;font-weight:800!important}#app-embed{position:relative}#app-embed::after,#app-embed::before{content:"";position:absolute;inset:0;background-repeat:no-repeat}#app-embed::after{opacity:.2;mix-blend-mode:difference;background-position:center;width:100%;height:100%;z-index:2}#app-embed::before{background-image:url(https://cdn.shopify.com/s/files/1/0824/7161/6798/files/gcww-vote_bg.webp?v=1770756580);z-index:1}section[data-sizing=form-wrapper]{max-width:unset!important}section[data-sizing=form-wrapper] fieldset{margin-bottom:4.8rem}section[data-sizing=form-wrapper] legend{display:none}section[data-sizing=form-wrapper] div:has(> label:not(#label-email)){grid-template-columns:repeat(2,minmax(0,1fr))!important;flex-direction:column!important}section[data-sizing=form-wrapper] div:has(input#email){margin:0 auto}section[data-sizing=form-wrapper] input[type=text]{padding:2rem 1.2rem 1.2rem!important;border:2px solid #000!important;line-height:125%!important;letter-spacing:-.84px!important;margin-top:7px}section[data-sizing=form-wrapper] input[type=radio],section[data-sizing=form-wrapper] label span{display:none!important}section[data-sizing=form-wrapper] label:has(input[type=radio]:checked)::after{content:""!important;position:absolute!important;bottom:14%!important;right:12%!important;width:80px!important;height:80px!important;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' fill='none' viewBox='0 0 80 80'%3E%3Ccircle cx='40' cy='40' r='38.5' stroke='%23fff' stroke-dasharray='6 6' stroke-width='3'/%3E%3Cpath stroke='%23fff' stroke-width='4' d='m21.917 43.523 8.946 8.714a1 1 0 0 0 1.396 0l25.824-25.153'/%3E%3C/svg%3E")!important}section[data-sizing=form-wrapper] label:has(input[type=radio]){cursor:pointer!important;position:relative!important;max-width:88vw!important;overflow:hidden!important;aspect-ratio:600/361!important;background-image:url(https://cdn.shopify.com/s/files/1/0824/7161/6798/files/gcww-postcard_01.png);background-size:contain;background-position:center;background-repeat:no-repeat}section[data-sizing=form-wrapper] label:has(input[type=radio]):nth-child(2){background-image:url(https://cdn.shopify.com/s/files/1/0824/7161/6798/files/gcww-postcard_02.png)}section[data-sizing=form-wrapper] label:has(input[type=radio]):nth-child(3){background-image:url(https://cdn.shopify.com/s/files/1/0824/7161/6798/files/gcww-postcard_03.png)}section[data-sizing=form-wrapper] label:has(input[type=radio]):nth-child(4){background-image:url(https://cdn.shopify.com/s/files/1/0824/7161/6798/files/gcww-postcard_04.png)}section[data-sizing=form-wrapper] label#label-email{line-height:0!important}section[data-sizing=form-wrapper] button{background:#000!important;color:#fff!important;line-height:36px!important;padding:.6rem 4.4rem .6rem 1.6rem!important;position:relative!important;width:min-content;margin:0 auto}section[data-sizing=form-wrapper] button::after{content:""!important;position:absolute!important;top:0!important;bottom:0!important;right:1.2rem!important;width:2rem!important;height:2rem!important;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='10' viewBox='0 0 11 10' fill='none'%3E%3Cpath d='M0.5 4.66667H10.5M10.5 4.66667L6.33333 0.5M10.5 4.66667L6.33333 8.83333' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")!important;background-repeat:no-repeat!important;background-position:center!important;background-size:contain!important;margin:auto!important}@media (min-width:900px){section[data-sizing=form-wrapper] div:has(> label:not(#label-email)){display:grid!important}#form-container-ref{max-width:77vw;margin:0 auto}}
					`;
					style.textContent = stylesForForm;
					shadow.appendChild(style);
					console.log("updated !!!!! ", shadow )
				}
			}
		}
	})
	observer.observe(shadowWrapper, {childList: true, subtree: true})

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		const formData = new FormData(form);
    	const vote = formData.get('gcww_drop_vote');
    	const email = formData.get('email');
		
		if(!!vote && !!email) {
			const formEmbed = document.querySelector(['shopify-forms-embed']);
			const shadow = formEmbed.shadowRoot;
			const shadowForm = shadow.querySelector('form');
			const shadowEmailInput = shadow.querySelector('input[type="text"]');
			const shadowRadioBtns = shadow.querySelectorAll('input[type="radio"]');
			const shadowSubmit = shadow.querySelector('button[type="submit"]');

			if(!!shadowEmailInput && !!shadowRadioBtns && !!shadowSubmit) {
				shadowEmailInput.focus();
				shadowEmailInput.click();
				shadowEmailInput.value = email;
				shadowEmailInput.dataset.kwcachedvalue = email;

				let shadowOptSelectVal = 'john a. roebling suspension bridge';

				switch (vote) {
					case 'gabp':
						shadowOptSelectVal = 'great american ball park';	
						break;
					case 'cmc':
						shadowOptSelectVal = 'cincinnati museum center';	
						break;
					case 'et':
						shadowOptSelectVal = 'esquire theatre';	
						break;
				}

				shadowRadioBtns.forEach(rb => {
					if(rb.value.toLowerCase() === shadowOptSelectVal) {
						console.log("bingo", {rb, shadowSubmit})
						rb.checked = true
						setTimeout(() => {
							// shadowForm.requestSubmit();
						}, 400);
					}
				})
			}
		}	
	})

	const submit = document.getElementById("gcww-vote-form-submit");

	const onRbUpdate = function(){
		if(!!submit) {
			if(submit.disabled) {
				submit.disabled = false;
			}
		}

	}

	if(!!form) {
		const opts = form.querySelectorAll('input[type="radio"]')
		opts.forEach(opt => {
			opt.addEventListener('change', onRbUpdate)
		})
	}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-header"]) return;
  try {
    
	const menuOpen = document.getElementById("menu-open");
	const menuClose = document.getElementById("menu-close");
	const mobileMenu = document.getElementById("mobile-menu");
	menuOpen.addEventListener("click", function() {
		mobileMenu.showModal()
		document.body.style.overflow = "hidden";
		document.body.style.height = "100%";
	});
	menuClose.addEventListener("click", function() {
		mobileMenu.close()
		document.body.style.overflow = "visible";
		document.body.style.height = "auto";
	});

  } catch(e) { console.error(e); }
})();
})();
